/* istanbul ignore file */
/**
 *
 * @param {Array} names
 * @param {String} key
 * @returns Object
 */
/* istanbul ignore next */
export default function groupByKey(names, key) {
  const groups = (names || []).reduce((acc, pill) => {
    const pillKey = pill[key];
    if (acc[pillKey]) {
      acc[pillKey].push(pill);
    } else {
      acc[pillKey] = [pill];
    }

    return acc;
  }, {});

  return groups;
}
